import { Option } from 'shared/components/Select/models/Option';
import { mapFurnitureLabel } from 'shared/constants/filters/advanced/mapFurnitureLabel';
import { EFurnitureType } from 'shared/types/filters/advanced/furnitureType';

export const furnitureOptions = [
  new Option(EFurnitureType.WithFurniture, mapFurnitureLabel[EFurnitureType.WithFurniture]),
  new Option(EFurnitureType.WithoutFurniture, mapFurnitureLabel[EFurnitureType.WithoutFurniture]),
];
